import {inject, injectable} from "inversify";
import type {IApiResponse, IHttpClientService} from "data/services/http";
import type {AxiosResponse} from "axios";
import {Bindings} from "data/constants/bindings";

export interface IRankingPayload {
	page?: number;
	limit?: number;
}

export interface IRanking {
	playerId: number;
	name: string;
	firstName: string;
	lastName: string;
	squadId: number;
	squadName: string;
	awards: number | null;
}

export interface IRankingResponse {
	rankings: IRanking[];
	nextPage: boolean;
}

export type TRankingResponse = IApiResponse<IRankingResponse>;
export interface IRankingApiProvider {
	ranking: (params: IRankingPayload) => Promise<AxiosResponse<TRankingResponse>>;
}

@injectable()
export class RankingApiProvider implements IRankingApiProvider {
	constructor(@inject(Bindings.ApiHTTPClient) private _http: IHttpClientService) {}

	ranking = (params: IRankingPayload) =>
		this._http.get<TRankingResponse>(`pog/ranking/leaderboard`, params);
}
